module.exports = __webpack_public_path__ + "static/media/twitter.c53cfc28.webp";